import React from "react";
import { Controller } from "react-hook-form";

import Input from "@/components/Atoms/Inputs/Input";
import ErrorUI from "@/components/Atoms/ErrorUI";

import { InputGroup, InputWrapper } from "../style";

const EmailInput = ({
  name,
  control,
  showLabels,
  emailPlaceholder,
  inputFontSize,
  inputLineHeight,
  handleBlur,
}) => (
  <InputWrapper>
    <InputGroup hasBottomBorder showLabels={showLabels}>
      <Controller
        name={name}
        control={control}
        render={({
          field: { value, onBlur, onChange, ref },
          fieldState: { error },
          formState: { errors },
        }) => (
          <>
            <Input
              ref={ref}
              type="email"
              name={name}
              placeholder={emailPlaceholder}
              value={value}
              onChange={onChange}
              onBlur={(e) => {
                e.persist();
                onBlur(e).then((e) => {
                  if (!errors?.[name]) handleBlur(e);
                });
              }}
              autoComplete="off"
              icon="icon-EnvelopeSimple"
              iconDimension="16px"
              variant="v2"
              inputFontSize={inputFontSize}
              inputLineHeight={inputLineHeight}
            />
            {error && <ErrorUI hasBottomBorder error={error?.message} />}
          </>
        )}
      />
    </InputGroup>
  </InputWrapper>
);

export default EmailInput;
